import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ $isLoginPage }) =>
    $isLoginPage
      ? css`
          padding: 0 0.5rem 1rem;
          a {
            color: #ffffff;
          }
        `
      : css`
          background: rgba(239, 239, 239, 0.31);
          backdrop-filter: blur(5px);
          -webkit-backdrop-filter: blur(5px);
          border-top: 1px solid rgba(255, 255, 255, 1);
          box-shadow:
            rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
            rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
          padding: 1rem;
          margin-top: 1rem;
          a {
            color: #000000;
          }
        `}

  text-align: center;
  font-weight: 500;
`;

export const Link = styled.a.attrs(() => ({
  target: '_blank',
}))`
  &:not(:first-child) {
    &:before {
      content: '|';
      padding: 0 0.4rem;
    }
  }
  &:hover {
    text-decoration: none;
  }
`;
